document.addEventListener("DOMContentLoaded", function () {

  /* =========================
     SWIPER (SAFE)
  ========================= */
  if (typeof Swiper !== "undefined") {
    const videoSwiper = new Swiper(".video-swiper", {
      slidesPerView: 3,
      spaceBetween: 15,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        0: { slidesPerView: 1.2 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });

    // Pause autoplay on hover
    const swiperContainer = document.querySelector('.video-swiper');
    if (swiperContainer) {
      swiperContainer.addEventListener('mouseenter', () => {
        videoSwiper.autoplay.stop();
      });
      swiperContainer.addEventListener('mouseleave', () => {
        videoSwiper.autoplay.start();
      });
    }
  }

  /* =========================
     VIDEO HOVER (FIXED - PAUSE ON HOVER)
  ========================= */
  function initVideoHover() {
    document.querySelectorAll(".video-thumb").forEach(video => {
      // Remove existing listeners to avoid duplicates
      video.removeEventListener("mouseenter", video._mouseEnterHandler);
      video.removeEventListener("mouseleave", video._mouseLeaveHandler);
      
      // Create new handlers
      const mouseEnterHandler = () => {
        video.play();
      };
      const mouseLeaveHandler = () => {
        video.pause();
        video.currentTime = 0; // Reset to beginning
      };
      
      // Store handlers for cleanup
      video._mouseEnterHandler = mouseEnterHandler;
      video._mouseLeaveHandler = mouseLeaveHandler;
      
      // Add event listeners
      video.addEventListener("mouseenter", mouseEnterHandler);
      video.addEventListener("mouseleave", mouseLeaveHandler);
    });
  }
  
  initVideoHover();

});


/* =========================
   GLOBAL CLICK HANDLER (FIXED VERSION)
========================= */
document.addEventListener("click", function (e) {

  /* =========================
     QUICK VIEW OPEN (WITH VIDEO SUPPORT)
  ========================= */
  const videoItem = e.target.closest(".video-item");
  if (videoItem) {
    e.preventDefault();
    const handle = videoItem.getAttribute("data-handle");
    
    // Get video URL from the clicked video
    const videoElement = videoItem.querySelector('video');
    const videoUrl = videoElement ? videoElement.getAttribute('src') : null;

    fetch(`/products/${handle}?view=quick`)
      .then(res => res.text())
      .then(html => {
        document.getElementById("qv-content").innerHTML = html;
        document.getElementById("qv-modal").style.display = "block";
        
        // If there's a video URL, replace main image with video
        if (videoUrl) {
          setTimeout(() => {
            const qvMainImage = document.querySelector('.qv-main-image');
            if (qvMainImage) {
              // Replace image with video
              qvMainImage.innerHTML = `
                <video 
                  src="${videoUrl}"
                  muted
                  autoplay
                  loop
                  playsinline
                  style="width: 100%; max-height: 420px; object-fit: contain; border-radius: 10px;">
                </video>
              `;
            }
          }, 100);
        }
        
        // Reinitialize gallery click handlers
        initQuickViewGallery();
        
        // Reinitialize offers selection
        initQuickViewOffers();
      })
      .catch(error => console.error('Error loading quick view:', error));

    return;
  }

  /* =========================
     QUICK VIEW CLOSE
  ========================= */
  if (e.target.closest(".qv-close") || e.target.closest(".qv-overlay")) {
    e.preventDefault();
    const modal = document.getElementById("qv-modal");
    if (modal) {
      modal.style.display = "none";
      // Clear content to stop any playing videos
      document.getElementById("qv-content").innerHTML = "";
    }
    return;
  }

  const modal = document.querySelector("#qv-modal");

  /* =========================
     QUICK VIEW UI (FIXED GALLERY)
  ========================= */
  if (modal && modal.style.display === "block") {

    // Gallery thumbnail click - change main image
    const galleryImg = e.target.closest(".qv-gallery img");
    if (galleryImg) {
      e.preventDefault();
      const mainContainer = modal.querySelector(".qv-main-image");
      const newImageUrl = galleryImg.getAttribute('src');
      
      // Replace with high-res version (remove width parameter)
      const highResUrl = newImageUrl.split('?')[0];
      
      // Check if current main is image or video
      const existingVideo = mainContainer.querySelector('video');
      if (existingVideo) {
        // If video exists, replace with image
        mainContainer.innerHTML = `<img src="${highResUrl}" alt="Product image" style="width: 100%; max-height: 420px; object-fit: contain; border-radius: 10px;">`;
      } else {
        // Just update image src
        const mainImg = mainContainer.querySelector('img');
        if (mainImg) {
          mainImg.src = highResUrl;
        }
      }
      return;
    }

    const accBtn = e.target.closest(".qv-accordion .acc button");
    if (accBtn) {
      e.preventDefault();
      const panel = accBtn.nextElementSibling;
      panel.style.display = panel.style.display === "block" ? "none" : "block";
      return;
    }

  }

  /* =========================
     GET SELECTED VARIANT (UNIFIED LOGIC)
  ========================= */
  function getVariantId(scope) {
    if (!scope) return null;

    // 1. checked radio inside scope
    const checked = scope.querySelector(".offer-radio:checked");
    if (checked) return checked.value;

    // 2. fallback (first checked anywhere visible)
    const globalChecked = document.querySelector(".offer-radio:checked");
    if (globalChecked) return globalChecked.value;

    return null;
  }

  /* =========================
     ADD TO CART (FIXED)
  ========================= */
  if (e.target.closest(".custom-add-to-cart")) {
    e.preventDefault();
    e.stopPropagation();

    const scope =
      e.target.closest(".qv-wrapper") ||
      e.target.closest(".offers-wrapper") ||
      document;

    const variantId = getVariantId(scope);

    if (!variantId) {
      alert("Please select an option");
      return;
    }

    // Disable button to prevent double-click
    const btn = e.target.closest(".custom-add-to-cart");
    if (btn) {
      btn.disabled = true;
      btn.style.opacity = "0.6";
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: 1
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    })
    .then(() => {
      window.location.href = "/cart";
    })
    .catch(error => {
      console.error('Error:', error);
      alert("There was an error adding to cart. Please try again.");
      if (btn) {
        btn.disabled = false;
        btn.style.opacity = "1";
      }
    });

    return;
  }

  /* =========================
     BUY NOW (FIXED)
  ========================= */
  if (e.target.closest(".custom-buy-now")) {
    e.preventDefault();
    e.stopPropagation();

    const scope =
      e.target.closest(".qv-wrapper") ||
      e.target.closest(".offers-wrapper") ||
      document;

    const variantId = getVariantId(scope);

    if (!variantId) {
      alert("Please select an option");
      return;
    }

    // Disable button to prevent double-click
    const btn = e.target.closest(".custom-buy-now");
    if (btn) {
      btn.disabled = true;
      btn.style.opacity = "0.6";
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: 1
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    })
    .then(() => {
      window.location.href = "/checkout";
    })
    .catch(error => {
      console.error('Error:', error);
      alert("There was an error processing your request. Please try again.");
      if (btn) {
        btn.disabled = false;
        btn.style.opacity = "1";
      }
    });

    return;
  }

});

/* =========================
   HELPER FUNCTION: Initialize Quick View Gallery
========================= */
function initQuickViewGallery() {
  // This function is called after quick view loads
  // Additional gallery initialization if needed
  const galleryImages = document.querySelectorAll('.qv-gallery img');
  galleryImages.forEach(img => {
    img.style.cursor = 'pointer';
  });
}

/* =========================
   HELPER FUNCTION: Initialize Quick View Offers (FIX FOR TICK)
========================= */
function initQuickViewOffers() {
  const qvModal = document.getElementById('qv-modal');
  if (!qvModal || qvModal.style.display !== 'block') return;
  
  // Function to update selected states
  function updateSelectedStates() {
    const allBoxes = qvModal.querySelectorAll('.offer-box');
    const allRadios = qvModal.querySelectorAll('.offer-radio');
    
    // Remove selected class from all boxes
    allBoxes.forEach(box => {
      box.classList.remove('selected');
    });
    
    // Add selected class to checked radio's parent
    allRadios.forEach(radio => {
      if (radio.checked) {
        const parentBox = radio.closest('.offer-box');
        if (parentBox) {
          parentBox.classList.add('selected');
        }
      }
    });
  }
  
  // Get all offer boxes inside quick view
  const offerBoxes = qvModal.querySelectorAll('.offer-box');
  const radioButtons = qvModal.querySelectorAll('.offer-radio');
  
  // Remove existing listeners to avoid duplicates (using clone)
  offerBoxes.forEach(box => {
    const newBox = box.cloneNode(true);
    box.parentNode.replaceChild(newBox, box);
  });
  
  // Re-get elements after clone
  const freshOfferBoxes = qvModal.querySelectorAll('.offer-box');
  const freshRadios = qvModal.querySelectorAll('.offer-radio');
  
  // Add click events to fresh boxes
  freshOfferBoxes.forEach(box => {
    box.addEventListener('click', function(e) {
      if (e.target.type === 'radio') return;
      
      const radio = this.querySelector('.offer-radio');
      if (radio && !radio.checked) {
        radio.checked = true;
        // Trigger change event
        const changeEvent = new Event('change', { bubbles: true });
        radio.dispatchEvent(changeEvent);
      }
    });
  });
  
  // Add change events to fresh radios
  freshRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      updateSelectedStates();
    });
  });
  
  // Initialize selected state
  updateSelectedStates();
}